function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useMemo } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import qs from 'qs';
import { useRequest, useMemoizedFn } from 'ahooks';
import { SLModal } from '@yy/sl-admin-components';
import { useTranslation } from '../../_utils/i18n';
import { getBillStatus } from '../../services';
import iconWechatPay from './images/wechatPay.png';
import { WeixinPayWrapper } from './styled';
import { useConfigAtomValues, useDataAtom, useStateAtom } from '../../state';
import { ProductId, WechatPayHostMap, EPayMethodType, EChannelId, EBillStatus } from '../../constants';
import { usePayMerchantInfo } from '../../hooks';
import fly from '../../http';
var HuifuWeiXinPayModal = function HuifuWeiXinPayModal(props) {
  var _fly$config, _fly$config$extra;
  var priceString = props.priceString,
    _onSuccess = props.onSuccess,
    onPayCancel = props.onPayCancel;
  var _useConfigAtomValues = useConfigAtomValues(),
    billId = _useConfigAtomValues.billId,
    appId = _useConfigAtomValues.appId,
    bizType = _useConfigAtomValues.bizType,
    subBizType = _useConfigAtomValues.subBizType,
    returnUrl = _useConfigAtomValues.returnUrl,
    email = _useConfigAtomValues.email,
    paymentID = _useConfigAtomValues.paymentID,
    paymentName = _useConfigAtomValues.paymentName,
    countryCode = _useConfigAtomValues.countryCode,
    _useConfigAtomValues$ = _useConfigAtomValues.productId,
    productId = _useConfigAtomValues$ === void 0 ? ProductId : _useConfigAtomValues$,
    language = _useConfigAtomValues.language,
    onCancelPay = _useConfigAtomValues.onCancelPay;
  var _useDataAtom = useDataAtom(),
    _useDataAtom2 = _slicedToArray(_useDataAtom, 2),
    billDetail = _useDataAtom2[0].billDetail,
    setDataAtom = _useDataAtom2[1];
  var _useStateAtom = useStateAtom(),
    _useStateAtom2 = _slicedToArray(_useStateAtom, 2),
    huifuWeiXinModalVisible = _useStateAtom2[0].huifuWeiXinModalVisible,
    setStateAtom = _useStateAtom2[1];
  var _usePayMerchantInfo = usePayMerchantInfo({
      payChannel: EChannelId.Huifu
    }),
    payMerchantId = _usePayMerchantInfo.payMerchantId;

  // 是否关闭支付弹窗的时候调用取消的api
  var isInvokeCancelApiOnClose = useMemoizedFn(function () {
    if (typeof (onCancelPay === null || onCancelPay === void 0 ? void 0 : onCancelPay.invokeCancelApiOnClose) === 'function') {
      return onCancelPay.invokeCancelApiOnClose({
        billId: billId,
        payMethod: EPayMethodType.HuifuWechat
      });
    }
    return false;
  });

  // 微信支付页-二维码参数

  // bizType有值，则代表主站，基参需要保留；bizType没值，则代表非主站，基参不需要再传
  var base = bizType === 'SHOPLINE' ? {
    appId: appId,
    bizType: bizType,
    subBizType: subBizType
  } : {};
  var queryQrcodeParams = _objectSpread(_objectSpread({}, base), {}, {
    billId: billId,
    returnUrl: returnUrl,
    email: email,
    productId: productId,
    paymentID: paymentID,
    paymentName: paymentName,
    region: countryCode,
    priceString: priceString,
    merchantId: payMerchantId,
    currency: billDetail === null || billDetail === void 0 ? void 0 : billDetail.orderCurrency,
    language: language,
    token: ((_fly$config = fly.config) === null || _fly$config === void 0 ? void 0 : (_fly$config$extra = _fly$config.extra) === null || _fly$config$extra === void 0 ? void 0 : _fly$config$extra.accessToken) || ''
  });
  var _useTranslation = useTranslation(),
    i18n = _useTranslation.t;

  // 微信H5支付页链接
  var WechatPayURL = useMemo(function () {
    var queryParams = qs.stringify(queryQrcodeParams, {
      addQueryPrefix: true
    });
    return "".concat(WechatPayHostMap[window.SETTLEMENT_SDK_ENV]).concat(queryParams);
  }, [huifuWeiXinModalVisible, queryQrcodeParams === null || queryQrcodeParams === void 0 ? void 0 : queryQrcodeParams.merchantId, queryQrcodeParams === null || queryQrcodeParams === void 0 ? void 0 : queryQrcodeParams.currency]);

  // 查询账单支付状态
  var _useRequest = useRequest(function () {
      return getBillStatus(queryQrcodeParams);
    }, {
      manual: true,
      pollingInterval: 1000,
      onSuccess: function onSuccess(res) {
        var _res$data, _res$data2;
        if ((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.status) === EBillStatus.PAYED) {
          setDataAtom(function (draft) {
            draft.billStatus = EBillStatus.PAYED;
          });
          cancelQueryBillStatus();
          setStateAtom(function (draft) {
            draft.huifuWeiXinModalVisible = false;
          });
          _onSuccess === null || _onSuccess === void 0 ? void 0 : _onSuccess({
            billId: billId
          });
        }
        if ((res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.status) === EBillStatus.CANCELED) {
          setDataAtom(function (draft) {
            draft.billStatus = EBillStatus.CANCELED;
          });
          setStateAtom(function (draft) {
            draft.huifuWeiXinModalVisible = false;
          });
          cancelQueryBillStatus();
        }
      }
    }),
    queryBillStatus = _useRequest.run,
    cancelQueryBillStatus = _useRequest.cancel;
  var clearTimer = function clearTimer() {
    cancelQueryBillStatus();
  };
  var onCancel = function onCancel() {
    setStateAtom(function (draft) {
      draft.huifuWeiXinModalVisible = false;
    });
    clearTimer();
    onPayCancel === null || onPayCancel === void 0 ? void 0 : onPayCancel({
      invokeCancelApi: isInvokeCancelApiOnClose()
    });
  };
  useEffect(function () {
    if (huifuWeiXinModalVisible) {
      clearTimer();
      // 轮询账单支付结果
      queryBillStatus();
    }
  }, [huifuWeiXinModalVisible]);
  return /*#__PURE__*/React.createElement(SLModal, {
    visible: huifuWeiXinModalVisible,
    centered: true,
    size: "small",
    title: i18n('settlement.payway.Wechat pay'),
    footer: false,
    onCancel: onCancel,
    maskClosable: false
  }, /*#__PURE__*/React.createElement(WeixinPayWrapper, null, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React.createElement("p", {
    className: "price"
  }, priceString), /*#__PURE__*/React.createElement("p", {
    className: "desc"
  }, i18n('settlement.WechatQRbox.save'))), /*#__PURE__*/React.createElement("div", {
    className: "body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "imgWrap"
  }, /*#__PURE__*/React.createElement(QRCodeSVG, {
    value: WechatPayURL,
    includeMargin: true,
    size: 300,
    level: 'M',
    imageSettings: {
      src: iconWechatPay,
      width: 32,
      height: 32,
      excavate: true
    }
  }))))));
};
export default HuifuWeiXinPayModal;